
/* ===== Page: Solutions – On-Fence Detection ===== */
import React from 'react';
import MainLayout from '@/components/Layout/MainLayout';
import {
  FenceHero,
  FenceOverview,
  FenceInstallation,
  FenceCompatibility,
  FenceFeatures,
  FenceCTA
} from '@/components/Solutions/Fence';

const SolutionsFence = () => {
  return (
    <MainLayout>
      <FenceHero />
      <FenceOverview />
      <FenceInstallation />
      <FenceCompatibility />
      <FenceFeatures />
      <FenceCTA />
    </MainLayout>
  );
};

export default SolutionsFence;
